import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private defaultConfig: MatSnackBarConfig = {
    duration: 3 * 1000,
    horizontalPosition: 'center',
    verticalPosition: 'top',
  };

  constructor(private snackbar: MatSnackBar) {}

  open(
    message: string,
    type: 'error' | 'feedback' | 'success' = 'feedback',
    action: string | undefined = undefined,
    config: MatSnackBarConfig = {},
  ) {
    const _config = Object.assign(
      JSON.parse(JSON.stringify(this.defaultConfig)),
      { ...config, panelClass: [`snackbar-${type}`] },
    );

    return this.snackbar.open(message, action, _config);
  }
}
